import { FC } from 'react'
import Card from '../card/Card'
import { LoadingSkeletonType } from './LoadingSkeleton.d'

export const Skeleton = () => {
  return (
    <div className="ant-skeleton ant-skeleton-active">
      <div className="ant-skeleton-content">
        <h3 className="ant-skeleton-title" style={{ width: '38%' }} />
        <ul className="ant-skeleton-paragraph">
          <li />
          <li />
          <li style={{ width: '61%' }}></li>
        </ul>
      </div>
    </div>
  )
}

const LoadingSkeleton: FC<LoadingSkeletonType> = ({
  numberOfSkeleton = 1,
  classNameSkeleton = '',
  useLoading = false,
  useRoutingLoading = false,
  useCustom,
  children
}) => {
  const arr = Array.from(new Array(numberOfSkeleton), (x, i) => i + 1)

  const renderSkeletonSearchingLoop = () => {
    return (
      <>
        {arr.map((arr) => {
          if (useCustom && useCustom.loading === true) {
            return useCustom.html
          }

          return (
            <Card key={`card-${arr}`} className={classNameSkeleton}>
              {Skeleton()}
            </Card>
          )
        })}
      </>
    )
  }

  const renderSkeletonRoutingLoop = () => {
    return (
      <>
        {arr.map((arr) => {
          if (useCustom && useCustom.routingLoading === true) {
            return useCustom.html
          }

          return (
            <Card key={`card-${arr}`} className={classNameSkeleton}>
              {Skeleton()}
            </Card>
          )
        })}
      </>
    )
  }

  return <>{useLoading ? renderSkeletonSearchingLoop() : useRoutingLoading ? renderSkeletonRoutingLoop() : children}</>
}

export default LoadingSkeleton
